module.exports = __webpack_public_path__ + "static/4-kola-55cf299162e2ddf053b3a48de224c1b6.jpg";